import { c as _c } from "react/compiler-runtime";
import { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { formatNumberWithCommas } from "@/helpers/Helpers";
interface WaveWinnersDropHeaderTotalVotesProps {
  readonly winner: ApiWaveDecisionWinner;
}
export default function WaveWinnersDropHeaderTotalVotes(t0) {
  const $ = _c(13);
  const {
    winner
  } = t0;
  let t1;
  if ($[0] !== winner.drop.rating || $[1] !== winner.place) {
    const topThreeRankStyles = {
      1: "tw-text-[#E8D48A]",
      2: "tw-text-[#DDDDDD]",
      3: "tw-text-[#CD7F32]"
    };
    const getVoteStyle = (rank, rating) => {
      if (rank && rank <= 3) {
        return topThreeRankStyles[rank];
      }
      if (rating >= 0) {
        return "tw-bg-gradient-to-r tw-from-emerald-400 tw-to-emerald-500 tw-bg-clip-text tw-text-transparent";
      }
      return "tw-bg-gradient-to-r tw-from-rose-400 tw-to-rose-500 tw-bg-clip-text tw-text-transparent";
    };
    t1 = getVoteStyle(winner.place, winner.drop.rating);
    $[0] = winner.drop.rating;
    $[1] = winner.place;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const style = t1;
  const t2 = `tw-font-bold tw-text-sm ${style}`;
  let t3;
  if ($[3] !== winner.drop.rating) {
    t3 = formatNumberWithCommas(winner.drop.rating);
    $[3] = winner.drop.rating;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <span className={t2}>{t3}</span>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== winner.drop.wave.voting_credit_type) {
    t5 = <span className="tw-text-sm tw-text-iron-500 tw-whitespace-nowrap">{winner.drop.wave.voting_credit_type} total</span>;
    $[8] = winner.drop.wave.voting_credit_type;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="tw-flex tw-items-baseline tw-gap-x-2">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}